import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { SafeStyle } from '@angular/platform-browser';
import { ProductService } from '../_services/product.service';
import { Title } from '@angular/platform-browser';
import { appsettings } from '../shared/app.settings';
import { NgClass } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  link: string;
  id: number;
  country: string;
  language: string;
  showAll= false ;
  ib: any = [];
  ibList: any = [];
  energyLabel: any;
  pdfLink: any;

  productName: string;
  productSize: any;
  specs: any;
 public product: any = [];
  features: any;
  image: SafeStyle;
  rootUrl: string;
  seeMore:string;
  seeFalse:string;
  view: boolean;
  public shouldShow = false;
  constructor(
    private productService: ProductService,
    private route: ActivatedRoute,
    public titleService: Title
  ) { }


  getProduct(link: string, country: string, language: string): void {
    //console.log(link);
    this.productService.getProduct(link, country, language)
      .subscribe(
        resultArray => {
          this.product = resultArray;
          this.productService.product.next(this.product[0]);
          this.features= resultArray[0].feature.bigFeature;
          if(this.features) {
            if(this.features.length <= 3){
              this.seeMore = 'none';
              this.seeFalse = 'none';
            }
          }
          //console.log(this.specs);

          for(let i = 0; i < resultArray[0].file.length; i++) {
            console.log('gg');

            if(resultArray[0].file[i].typeCode == 'ib') {
              //this.ib = resultArray[0].file[i];
              //this.ibList = new Array();
              console.log(resultArray[0].file[i])
              this.ibList[i] = resultArray[0].file[i];
            }else if(resultArray[0].file[i].typeCode == 'energy') {
              this.energyLabel = resultArray[0].file[i];
            }
          }
          //console.log(this.ibList);
          this.productName = resultArray[0].name;
          console.log(this.product);
          this.titleService.setTitle(this.productName + ' - ' + appsettings.siteTitle);
        },
        error => console.log('Error ::' + error)
      );
      //console.log(this.product);
  }


showFeature() {
  this.showAll = !this.showAll;
  this.view = !this.view;
}



  ngOnInit(): void {

    setTimeout(() => {
      $(document).foundation();
    }, 2000);

    this.rootUrl = appsettings.rootUrl;
    console.log(this.product);

    this.route.params
      .subscribe(
        (params: Params) => {
          // this.id = +params['id'];
          this.link = params['link'];
          this.pdfLink = 'http://34.244.173.118:6060/';
          this.country = params['country'];
          this.language = params['language'];
          this.getProduct(this.link, this.country, this.language);
        }
      );
  }
}
